import type { Direction, Occasion, ProductType } from './product';

export const DIRECTION_LABELS: Record<Direction, string> = {
  body: 'Тело и образ',
  care: 'Забота о себе',
  mind: 'Мысли и развитие',
};

export const OCCASION_LABELS: Record<Occasion, string> = {
  practice: 'Практика',
  everyday: 'Каждый день',
  walk: 'Прогулка',
  home: 'Дома',
  'after-training': 'После тренировки',
  gift: 'Подарок',
};

export const TYPE_LABELS: Record<ProductType, string> = {
  top: 'Верх',
  bottom: 'Низ',
  practice: 'Для практики',
  objects: 'Предметы',
};

export { AVAILABILITY_LABELS } from '@/shared/lib/availability';
